import React from 'react';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import { Row, Col } from 'reactstrap';
import * as moment from 'moment'
import DatePicker from "../../common/DatePicker"
import organizationService from "../../../services/organizationService"

const options = {
    autoClose: 3000,
    hideProgressBar: true,
};

export default class OrganizationStats extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            extensions: [],
            callsMap: {},
            totalCallsMap: {},
            extensionStats: [],
            fromDate: moment().startOf('month').toDate(),
            toDate: new Date()
        }

        this.handleFromDateSelect = this.handleFromDateSelect.bind(this)
    }

    componentDidMount() {
        this.loadOrganizationStats()
    }

    async loadOrganizationStats() {
        const { fromDate, toDate } = this.state
        try {
            const result = await organizationService.getOrganizationStatsForPeriod(this.props.organization._id, moment(fromDate).format('YYYY-MM-DD'), moment(toDate).format('YYYY-MM-DD'))
            const { extensions, callsMap, totalCallsMap } = result
            const extensionStats = extensions.map(({ _id, name }) => ({
                name,
                count: callsMap[_id].count,
                minutes: callsMap[_id].minutes,
                sipCount: callsMap[_id].sipCount,
                sipMinutes: callsMap[_id].sipMinutes,
                pstnCount: callsMap[_id].pstnCount,
                pstnMinutes: callsMap[_id].pstnMinutes,
            })).sort((first, second) => first.minutes < second.minutes ? 1 : first.minutes === second.minutes ? 0 : -1)
            this.setState({ extensions, callsMap, totalCallsMap, extensionStats })
        } catch (error) {
            toast.error(error.response, options)
        }
    }

    handleFromDateSelect(data) {
        this.setState({ fromDate: data.selection.startDate }, this.loadOrganizationStats)
    }

    render() {
        const { extensionStats, fromDate } = this.state
        return (
            <div>
                <Modal size="lg" show={this.props.show} onHide={this.props.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <Row>
                                <Col xs="6" sm="12">Organization Statistics</Col>
                                <Col xs="6" sm="12"><DatePicker fromDate={fromDate} onSelect={this.handleFromDateSelect} /></Col>
                            </Row>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <br />
                        <h4>Extensions calls statistics</h4>
                        <table className="table  mb-0">
                            <thead className="lightblue-bg">
                                <tr>
                                    <th className="border-0"> #</th>
                                    <th className="border-0">Name</th>
                                    <th className="border-0">Call count</th>
                                    <th className="border-0 ">Minutes</th>
                                    <th className="border-0">P2P count</th>
                                    <th className="border-0 ">P2P Minutes</th>
                                    <th className="border-0">PSTN count</th>
                                    <th className="border-0 ">PSTN Minutes</th>
                                </tr>
                            </thead>
                            <tbody>
                                {extensionStats.map((statsData, i) =>
                                    (<tr key={'extensionStats -' + i}>
                                        <td>{i + 1}</td>
                                        <td>{statsData.name}</td>
                                        <td>{statsData.count}</td>
                                        <td>{statsData.minutes}</td>
                                        <td>{statsData.sipCount}</td>
                                        <td>{statsData.sipMinutes}</td>
                                        <td>{statsData.pstnCount}</td>
                                        <td>{statsData.pstnMinutes}</td>
                                    </tr>
                                    ))}
                            </tbody>
                        </table>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-lightblue" onClick={this.props.handleClose}>
                            Close
                        </button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/organizationComponent/modals/organizationStats.js